/**
 * Onboarding Email
 */
window.OnboardingEmail = {
	
    settings: {
        route : 'onboarding',
        routePrefs : 'prefsNylas'
    },

    /**
     * Init form auth
     */
    initForm: function(provider)
    {
        var options = {
            beforeSubmit: function() {
                var loader = MyWindow.getLoader();
                $('#authForm').append(loader);
            },
            success: function(data) {
                var formIsOk = MyForm.processJson(data, "authForm");
                if (formIsOk) {
                    Utils.relocate('/?_f=onboarding&action=email&step=4&provider=exchange');
                }
                $('#authForm').find('.loader-logo').remove();
            },
            dataType: "json"
        };
        MyForm.prepare("authForm", "prefsNylas&action=oauth"+Utils.ucfirst(provider), options);
        MyFacture.customForm();
    },

    /**
     * Auth Office365 provider
     * @param provider
     */
    auth: function (provider)
    {
        var self = this;

        MyFacture.post(self.settings.routePrefs, {action: 'oauth'+Utils.ucfirst(provider)});
    },

    /**
     *
     * @param urlRedirect
     */
	goToParameters: function(urlRedirect)
	{
		var self = this;
		// On stock l'url où l'on se trouve pour rédiriger le client après son onboarding
		MyFacture.post(
			self.settings.route,
			{
				action : 'callbackRedirect',
				urlOverview	: location.search,
				module : 'email'
			},
			function (data) {
				if (data.result == "ok") {
					window.location.href = urlRedirect;
				}
			}, "json"
		);
	},

    /**
     *
     * @param id
     */
	switchTab: function(id)
	{
		$('.tab-v-container .tab-v-menu li a#'+id).click();
	}
};